import {Fancybox} from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox.css'
import SearchEngineEnum from '../enumerators/search-engine.enum'

export default class BookingComponent {
	isMobile = window.matchMedia('(max-width: 1000px)').matches

	constructor() {
		this.initDatePicker()
		this.init_forms()
	}

	initDatePicker() {
		if (this.isMobile) {
			$('.tools__item--cart').prependTo('.header__navbar__tools')
		}

		if ($(SearchEngineEnum.SEARCH_ENGINE_FORM).length > 0){
			import('@easepick/bundle').then(({AmpPlugin, easepick, LockPlugin, RangePlugin}) => {
				Fancybox.bind('[data-customer-modal]', {
					click: false,
				})

				$(SearchEngineEnum.SEARCH_ENGINE_FORM).each(function () {
					const startDateElement = $(this).find(SearchEngineEnum.SEARCH_ENGINE_STARTDATE)
					const endDateElement = $(this).find(SearchEngineEnum.SEARCH_ENGINE_ENDDATE)

					const picker = new easepick.create({
						element: $(startDateElement)[0],
						format: 'DD/MM/YYYY',
						css: [
							'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
							Customer.easePickStylesheet,
						],
						inline: false,
						calendars: this.isMobile ? 1 : 2,
						grid: this.isMobile ? 1 : 2,
						zIndex: 10,
						lang: 'fr-FR',
						AmpPlugin: {
							resetButton: true,
						},
						LockPlugin: {
							minDate: new Date(),
						},
						RangePlugin: {
							tooltip: false,
							elementEnd: $(endDateElement)[0],
						},
						plugins: [LockPlugin, AmpPlugin, RangePlugin],
					})
				})
			})
		}
	}

	init_forms() {
		// Form submit
		$(SearchEngineEnum.SEARCH_ENGINE_FORM).submit(function (e) {
			e.preventDefault()
			const id = $(this).attr('data-engine-form')

			const values = {}
			$.each($(this).serializeArray(), (i, field) => {
				values[field.name] = field.value
				if (field.name === 'enddate' || field.name === 'startdate') {
					const parts = field.value.split('/')
					values[field.name] = `${parts[2]}-${parts[1]}-${parts[0]}`
				}
			})

			switch (id) {
				case 'hosting':
					if (values.url && values.startdate && values.enddate) {
						const url = `${values.url}recherche/marketplace/${values.startdate}/${values.enddate}/${values.nbperson ? `${values.nbperson}/0/` : '0/0'}`
						window.location.href = url
					}
					break
				default:
					if (values.url && values.startdate && values.enddate) {
						const url = `${values.url}recherche/marketplace/${values.startdate}/${values.enddate}/0/0/`
						window.location.href = url
					}
					break
			}
		})
	}
}
